import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpService } from '../../../utility/http-service';
import { LoginService } from '../../../../services/login-service';
import { UserClient } from '../../../../services/login-service';
import { DialogService } from '../../../utility/dialog/dialog-service';

@Component({
  selector: 'archive-schedules-dialog',
  standalone: false,
  templateUrl: './archive-schedules.component.html',
  styleUrl: './archive-schedules.component.css'
})
export class ArchiveSchedulesComponent implements OnInit {

  clients: UserClient[] = [];
  selectedClientId: string = '';
  beforeDate: string = '';
  previewCount: number | null = null;
  isLoading = false;
  isArchiving = false;
  archiveComplete = false;
  archivedCount = 0;
  pendingConfirm = false;

  get isGlobalAdmin(): boolean {
    return this.loginService.user.isGlobalAdmin;
  }

  get clientDisplayName(): string {
    const client = this.loginService.user.availableClients?.find(c => c.id === this.selectedClientId);
    return client?.displayName ?? this.selectedClientId;
  }

  constructor(
    public dialogRef: MatDialogRef<ArchiveSchedulesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpService,
    public loginService: LoginService,
    private ds: DialogService
  ) {}

  ngOnInit(): void {
    if (this.isGlobalAdmin) {
      this.clients = this.loginService.user.availableClients ?? [];
      this.selectedClientId = this.loginService.user.selectedClientId || this.loginService.user.defaultClientId;
    } else {
      this.selectedClientId = this.loginService.user.selectedClientId || this.loginService.user.defaultClientId;
    }
  }

  preview(): void {
    if (!this.beforeDate || !this.selectedClientId) {
      this.ds.showError('Please select a company and date.');
      return;
    }

    this.isLoading = true;
    this.previewCount = null;

    this.http.post('FracX/ArchiveSchedulesPreview', (res: any) => {
      this.previewCount = res.count;
      this.isLoading = false;
    }, { clientId: this.selectedClientId, beforeDate: this.beforeDate });
  }

  confirm(): void {
    if (this.previewCount === null || this.previewCount === 0) return;
    this.pendingConfirm = true;
  }

  proceedArchive(): void {
    this.pendingConfirm = false;
    this.isArchiving = true;
    this.http.post('FracX/ArchiveSchedules', (res: any) => {
      this.isArchiving = false;
      this.archiveComplete = true;
      this.archivedCount = res.affected;
    }, { clientId: this.selectedClientId, beforeDate: this.beforeDate });
  }

  cancelConfirm(): void {
    this.pendingConfirm = false;
  }

  reset(): void {
    this.previewCount = null;
    this.archiveComplete = false;
    this.archivedCount = 0;
    this.pendingConfirm = false;
  }

  close(): void {
    this.dialogRef.close(this.archiveComplete);
  }
}
